const domain = '/krpt'
export default {
  getArticlePager: domain + '/shop/article/getArticlePager',
  queryLabelConfig: domain + '/shop/article/queryLabelConfig',
  queryUserIsBuyArticle: domain + '/shop/article/queryUserIsBuyArticle',
  userBuyArticle: domain + '/shop/article/userBuyArticle',
  getArticleInfo: domain + '/shop/article/getArticleInfo',
  setLeaveMessage: domain + '/shop/article/setLeaveMessage',
  queryArticleMessageList: domain + '/shop/article/queryArticleMessageList',
  getUserSigninInfo: domain + '/shop/article/getUserSigninInfo',
  userSignin: domain + '/shop/article/userSignin',
  getArticleTopPager: domain + '/shop/article/getArticleTopPager',
  getHomeConfigByType: domain + '/shop/article/getHomeConfigByType',
  userIsClickLikeArticle: domain + '/shop/article/userIsClickLikeArticle',
  userClickLikeArticle: domain + '/shop/article/userClickLikeArticle',
  userIsClickCollectArticle: domain + '/shop/article/userIsClickCollectArticle',
  userClickCollectArticle: domain + '/shop/article/userClickCollectArticle'
}
